import React, { useState, useEffect } from 'react';

import { useStateValue } from '@contexts/StateProvider';

import { useProject, forceReloadProject } from '@hooks/API/Project/UseProject';

import EventDrawer from '@components/EventDrawer/EventDrawer';
import EmptyState from '@components/Gui/EmptyState';
import { Loading } from '@components/Gui/Loading';
import { NwAddButton } from '@components/Gui/NwButton';
import NwIcon from '@components/Gui/NwIcon';
import TaskCard from '@components/TaskList/TaskCard';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ProjectPageTaskList = ({ projectId, previewMode }) => {
    //onReloadTodos

    const [addDrawer, setAddDrawer] = useState(false);
    const [{ areaContext }] = useStateValue();

    const { data: currentProject, isFetching } = useProject(projectId);

    const [projectTasks, setProjectTasks] = useState([]);

    useEffect(() => {
        if (!isFetching && currentProject) {
            //const te = onGetOrderedEventList(currentProject, areaContext, false, false)
            //setProjectEvents(te)

            const tds = currentProject.ToDos.filter((todo) => {
                if (
                    todo.Visibility.Areas.length === 0 ||
                    todo.Visibility.Areas.find((area) => area === areaContext.area)
                ) {
                    return true;
                }
                return false;
            });
            setProjectTasks(tds);
        }

    }, [currentProject, isFetching]);

    const handleOpenAddTodoDialog = () => {
        setAddDrawer(true);
    };

    const handleCloseAddDrawer = () => {
        setAddDrawer(false);
    };

    const onReloadTodos = () => {
        forceReloadProject(projectId);
    };

    const filteredTasks = projectTasks.filter((todo) => todo.GlobalStatus !== 'Completed');

    return isFetching ? (
        <Loading />
    ) : (
        <div className="internal-card first-line">
            <div className="header">
                <div className="title-container">
                    <NwIcon className="icon" icon={byPrefixAndName.fasl['list-check']} />
                    <div className="title">Tasks</div>
                </div>
                {!previewMode && <NwAddButton ghost size="small" label="new task" onClick={handleOpenAddTodoDialog} />}
            </div>
            <div className="content">
                <div className="content">
                    {filteredTasks.length > 0 ? (
                        filteredTasks.map((todo, index) => {
                            return (
                                <div className="todo-item" key={index}>
                                    <TaskCard
                                        todoItem={todo}
                                        showAll={true}
                                        todoType={'public'}
                                        projectId={projectId}
                                        onUpdate={onReloadTodos}
                                    />
                                </div>
                            );
                        })
                    ) : (
                        <EmptyState message="No tasks" />
                    )}
                </div>
            </div>
            {addDrawer && (
                <EventDrawer
                    viewMode="create"
                    onClose={handleCloseAddDrawer}
                    afterUpdate={onReloadTodos}
                    eventType="todo"
                    projectId={projectId}
                />
            )}
        </div>
    );
};

export default ProjectPageTaskList;
